import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './VideoLoopWrap.module.scss';
import VideoLoop from './VideoLoop';
import { SubHeading } from '../typography/Typography';

const VideoLoopWrap = ({ videoOptions, selectedVideo }) => {
  const items = [];

  Object.keys(videoOptions).forEach((key, index) => {
    items.push(
      <div
        key={[index, 'Video Loop']}
        className={classNames(
          styles.videoLoop,
          key === selectedVideo ? styles.selected : ''
        )}
      >
        {videoOptions[key].description && (
          <SubHeading variant="small">
            {videoOptions[key].description}
          </SubHeading>
        )}
        <VideoLoop
          title={`${videoOptions[key].label} Animation`}
          src={videoOptions[key].video}
        />
      </div>
    );
  });

  return <div>{items}</div>;
};

VideoLoopWrap.propTypes = {
  videoOptions: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string))
    .isRequired,
  selectedVideo: PropTypes.string.isRequired,
};

export default VideoLoopWrap;
